// extracted by mini-css-extract-plugin
export default {"root":"IconDelete_root__c6sNS"};